import {BankAccountResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export interface BankAccountDetails {
  iban: string | Nullish;
  swift: string | Nullish;
}

/**
 * Extracts IBAN and SWIFT from the selected bank account.
 * Returns null values if bank account not found or fields are missing.
 *
 * @param selectedAccountNumber - The account number to find
 * @param availableBankAccounts - List of available bank accounts
 * @returns Object with iban and swift (null if not found)
 */
export const getBankAccountDetails = (
  selectedAccountNumber: string | Nullish,
  availableBankAccounts: BankAccountResponseBody[] | Nullish
): BankAccountDetails => {
  if (!selectedAccountNumber || !availableBankAccounts) {
    return {iban: null, swift: null};
  }

  const account = availableBankAccounts.find((acc) => acc.accountNumber === selectedAccountNumber);

  return {
    iban: account?.iban ?? null,
    swift: account?.swift ?? null,
  };
};
